import React from "react";
import { Layout, Menu } from "antd";
import {
    FileProtectOutlined,
    PhoneOutlined
} from "@ant-design/icons";
import "./App.css";
import HasarIhbarPage from "./HasarIhbarPage";
import HasarTipiPage from "./HasarTipiPage";
import HasarIhbarKaskoPage from "./HasarIhbarKaskoPage";
import KaskoIhbarBildirimPage from "./KaskoIhbarBildirimPage";
import KaskoIhbarBasariliPage from "./KaskoIhbarBasariliPage";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HasarProvider } from "./HasarContext";
import zurichLogo from "./assets/zurich-logo.png";

const { Header, Content, Footer } = Layout;

function App() {
    return (
        <HasarProvider>
            <Layout className="main-layout">
                <Header className="header">
                    <div className="header-container">
                        <div className="logo">
                            <img
                                src={zurichLogo}
                                alt="Zurich Sigorta"
                                style={{ height: 80, width: "auto" }}
                            />
                        </div>
                    </div>
                </Header>
                <Content className="content has-footer">
                    <Routes>
                        <Route path="/" element={<HasarIhbarPage />} />
                        <Route path="/hasartipi" element={<HasarTipiPage />} />
                        <Route path="/kasko" element={<HasarIhbarKaskoPage />} />
                        <Route path="/kasko/ihbar" element={<KaskoIhbarBildirimPage />} />
                        <Route path="/kasko/ihbar/basarili" element={<KaskoIhbarBasariliPage />} />
                        {/*<Route path="/iletisim" element={<div style={{ background: "#fff", padding: 24 }}>İletişim bilgileri buraya gelecek.</div>} />*/}
                        <Route path="*" element={<div style={{ padding: 24 }}>Sayfa bulunamadı.</div>} />
                    </Routes>
                </Content>
                <Footer className="footer">
                    Zurich Sigorta &copy; {new Date().getFullYear()} - Tüm Hakları Saklıdır.
                </Footer>
            </Layout>
        </HasarProvider>
    );
}

export default App;
